import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { keepPreviousData } from '@tanstack/react-query';
import { showError } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
export const useViews = (networkId, updateTimestamps) => {
  const $ = _c(11);
  let t0;
  if ($[0] !== networkId) {
    t0 = {
      networkId
    };
    $[0] = networkId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!networkId && !!updateTimestamps;
  let t2;
  if ($[2] !== t1) {
    t2 = {
      enabled: t1,
      placeholderData: keepPreviousData
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: views,
    isLoading,
    refetch,
    error
  } = trpc.view.getViews.useQuery(t0, t2);
  let t3;
  let t4;
  if ($[4] !== error) {
    t3 = () => {
      if (error) {
        showError("Failed to load views for the chosen network", {
          description: "Please check your internet connection and try again"
        });
      }
    };
    t4 = [error];
    $[4] = error;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== isLoading || $[8] !== refetch || $[9] !== views) {
    t5 = {
      views,
      isLoading,
      refetch
    };
    $[7] = isLoading;
    $[8] = refetch;
    $[9] = views;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default useViews;